// Importing necessary modules and dependencies
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { shuffle } from '../common/array-util';
import gsap from 'gsap';

export default class GameScene {
  // Constructor takes a scene and camera as parameters
  constructor(scene, camera) {
    this.scene = scene;
    this.camera = camera;

    this.onEvents = this.onEvents.bind(this);
  }

  // Initialization method for setting up event listeners and initial state
  init(gui) {
    // this.collect1Audio = new Audio('./sounds/collect.mp3');
    // this.collect2Audio = new Audio('./sounds/collect.mp3');
    // this.collect3Audio = new Audio('./sounds/collect.mp3');

    this.gui = gui;
    this.cages = [];
    this.events = EventDispatcher.getObj();

    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents);
    this.events.addEventListener('GAME_EVENTS', this.onEvents);

    // this.scene.fog = new THREE.Fog(0xcccccc, 10 * 3, 15 * 3);
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'create_scene':
        this.createScene();
        break;
      case 'update':
        this.update(data['message']['data']);
        break;
      case 'start_time':
        // this.startTimer();
        break;
      case 'pringle_collected':
        this.onPringleCollected(data['message']['data']);
        break;
      case 'start_game':
        this.playPringleSound();
        break;
      case 'hit_sound':
        data['message']['data']['isWall']
          ? this.playWallHitSound()
          : this.playCarHitSound();
        break;
      case 'disappear_pringles':
        this.disappearAllPringles();
        break;
      case 'dispose':
        this.dispose();
        break;
    }
  }
  disappearAllPringles() {
    Global.pringles.forEach((pringle, i) => {
      gsap.to(pringle.scale, {
        x: 0,
        y: 0,
        z: 0,
        duration: 0.25,
        delay: Math.min(0.5, i * 0.01),
        ease: 'back.out',
      });
    });
  }
  playPringleSound() {
    if (!Global.soundEnabled) return;

    const source = Global.audioContext.createBufferSource();
    source.buffer = Global.pringlesBuffer; // Use the pre-decoded buffer
    source.connect(Global.audioContext.destination);
    source.start(0); // Start playback immediately
  }
  playWallHitSound() {
    if (!Global.soundEnabled) return;

    const source = Global.audioContext.createBufferSource();
    source.buffer = Global.hit2Buffer; // Use the pre-decoded buffer
    source.connect(Global.audioContext.destination);
    source.start(0); // Start playback immediately
  }
  playCarHitSound() {
    if (!Global.soundEnabled) return;

    const source = Global.audioContext.createBufferSource();
    source.buffer = Global.hit1Buffer; // Use the pre-decoded buffer
    source.connect(Global.audioContext.destination);
    source.start(0); // Start playback immediately
  }

  async createScene() {
    Global.pringles = [];
    this.totalPringlesAdded = 0;
    this.addScene();

    Global.collectablesConfig2 = [...shuffle(Global.collectablesConfig)];
    const initPos = {
      position: new THREE.Vector3(-132.5 + 127.3, 1, -20),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    };
    Global.collectablesConfig2.unshift(initPos);
    Global.pringlesSet = -1;
    for (let i = 0; i < 80; i++) {
      Global.pringlesSet++;

      this.addPringle(Global.collectablesConfig2[Global.pringlesSet]);
    }
    this.pringlesTI = setInterval(() => {
      if (Global.pringlesCollected >= this.totalPringlesAdded * 0.1) {
        Global.pringlesSet++;
        if (Global.pringlesSet >= Global.collectablesConfig2.length) {
          this.pringlesTI && clearInterval(this.pringlesTI);

          return;
        }

        this.addPringle(Global.collectablesConfig2[Global.pringlesSet]);
      }
    }, 1000);
    Global.collectablesConfig2.forEach((config) => {});

    for (let i = 1; i <= 5; i++) {
      this[`point${i}`] = new THREE.Mesh(
        new THREE.PlaneGeometry(0.3, 0.3),
        new THREE.MeshBasicMaterial({
          map: Global.assets['textures']['point']['asset'],
          transparent: true,
          opacity: 0,
        })
      );
      this.scene.add(this[`point${i}`]);
    }
  }
  addPringle(data) {
    const { count } = data;
    for (let i = 0; i < count; i++) {
      this.pringle = Global.assets['glbs']['pringle']['asset'].scene.clone();

      this.totalPringlesAdded++;
      this.scene.add(this.pringle);

      this.pringle.scale.set(0, 0, 0);
      this.pringle.position.copy(data.position);
      this.pringle.position.addScaledVector(data.direction, i);
      this.pringle.rotation.setFromVector3(data.rotation);
      this.pringle.rotation.z += i % 2 == 0 ? 0.2 : -0.2;

      this.pringle.userData.collected = true;
      this.pringle.userData.speed = Math.max(0.3, Math.random());
      Global.pringles.push(this.pringle);

      this.initScaleTwn = gsap.to(this.pringle.scale, {
        x: 0.2,
        y: 0.2,
        z: 0.2,
        duration: 0.5,
        delay: i * 0.1,
        onComplete: function (pringle) {
          pringle.userData.collected = false;
        }.bind(this, this.pringle),
        ease: 'bounce.out',
      });
      this.pringle.userData.initScaleTwn = this.initScaleTwn;

      const _map =
        Global.assets['textures'][
          `product_${Math.floor(Math.random() * 10) + 1}`
        ]['asset'];
      _map.wrapT = 1;

      let pringleChecked = false;
      Global.pringlesToCollide.push(this.pringle);
      this.pringle.traverse((item) => {
        if (item.isMesh) {
          if (pringleChecked) {
            // Global.pringlesToCollide.push(item);
          }
          pringleChecked = true;

          item.material = new THREE.MeshStandardMaterial();
          item.material.map = _map;

          item.material.envMapIntensity = Global.envIntensity;
          item.material.envMap = Global.envMap2;
          item.material.metalness = 0.5;

          _map.flipY = false;
          item.castShadow = true;
          if (item.material) {
            item.material.map.colorSpace = THREE.SRGBColorSpace;
            item.material.map.encoding = THREE.sRGBEncoding;

            item.material.map.anisotropy = Global.maxAniso;
          }
        }
      });
    }
  }
  onPringleCollected(data) {
    const { uuid } = data;
    const itemToRemove = this.scene.getObjectByProperty('uuid', uuid);

    if (itemToRemove.userData.collected) return;

    let removeIndex = -1;
    Global.pringles.forEach((pringle, index) => {
      if (pringle.uuid == uuid) {
        removeIndex = index;
      }
    });
    if (removeIndex > -1) {
      Global.pringles.splice(removeIndex, 1);
      Global.pringlesToCollide.splice(removeIndex, 1);
    }

    itemToRemove.userData.collected = true;
    Global.pringlesCollected++;
    document.querySelector('#game_header .score_sec .label').innerHTML = `${
      Global.pringlesCollected < 10 ? '0' : ''
    }${Global.pringlesCollected}`;

    // document.querySelector(
    //   `#collect${(Global.pringlesCollected % 5) + 1}Audio`
    // ).currentTime = 0;

    // this[`soundTO${(Global.pringlesCollected % 5) + 1}`] &&
    //   clearTimeout(this[`soundTO${(Global.pringlesCollected % 5) + 1}`]);
    // this[`soundTO${(Global.pringlesCollected % 5) + 1}`] = setTimeout(() => {

    // }, 10);

    this.playPringleSound();
    // document.querySelector(
    //   `#collect${((Global.pringlesCollected + 1) % 5) + 1}Audio`
    // ).currentTime = 0;
    // Global.soundEnabled &&
    //   document
    //     .querySelector(`#collect${(Global.pringlesCollected % 5) + 1}Audio`)
    //     .play();
    // const point = new THREE.Mesh(
    //   new THREE.PlaneGeometry(0.3, 0.3),
    //   new THREE.MeshBasicMaterial({
    //     map: Global.assets['textures']['point']['asset'],
    //     transparent: true,
    //   })
    // );

    // this.scene.add(point);
    const point = this[`point${(Global.pringlesCollected % 5) + 1}`];
    // point.scale.set()
    point.material.opacity = 1;
    point.position
      .copy(itemToRemove.position.clone())
      .addScaledVector(new THREE.Vector3(0, 0.3, 0), 1);
    point.lookAt(this.camera.position);
    // point.scale.set(0, 0, 0);

    this.posTwn = gsap.to(point.position, {
      y: `+=${0.5}`,
      duration: 0.2,
      ease: 'back.out',
    });
    const ptOp = {
      value: 1,
    };
    this.alphaTwn = gsap.to(ptOp, {
      value: 0,
      duration: 0.3,
      delay: 0.25,
      onUpdate: function (ptOp, point) {
        if (point) {
          point.material.opacity = ptOp.value;
        }
      }.bind(this, ptOp, point),
    });
    point.userData.posTwn = this.posTwn;
    point.userData.alphaTwn = this.alphaTwn;
    this.removeScaleTwn = gsap.to(itemToRemove.scale, {
      x: 0.0,
      y: 0.0,
      z: 0.0,
      duration: 0.15,
      ease: 'back.in',
      onUpdate: function (itemToRemove, pringlesCollected) {
        itemToRemove.rotation.z +=
          (Math.PI / 20) * (pringlesCollected % 2 == 0 ? 1 : -1);
      }.bind(this, itemToRemove, Global.pringlesCollected),
      onComplete: function (itemToRemove) {
        this.scene.remove(itemToRemove);
        // itemToRemove.visible = false;
        itemToRemove.traverse((item) => {
          if (item.isMesh) {
            item.geometry.dispose();
            item.material && item.material.dispose();
          }
        });
        itemToRemove = null;
      }.bind(this, itemToRemove),
    });
    itemToRemove.userData.removeScaleTwn = this.removeScaleTwn;
  }
  // Method to add a track to the scene based on a given index
  addScene() {
    this.city = Global.assets['glbs']['city']['asset'].scene.clone();
    this.scene.add(this.city);

    this.road = Global.assets['glbs']['road']['asset'].scene.clone();
    this.scene.add(this.road);

    this.wheel = Global.assets['glbs']['sky_wheel']['asset'].scene.clone();
    this.scene.add(this.wheel);
    this.wheel.position.set(36.5187, 16.4811, -60.2515);
    this.wheel.traverse((item) => {
      if (item.isMesh) {
        item.material.envMapIntensity = Global.envIntensity;
        if (item.material.map) {
          item.material.map.colorSpace = THREE.SRGBColorSpace;
          item.material.map.encoding = THREE.sRGBEncoding;
        }

        if (item.material.name.includes('glass')) {
          item.material.envMapIntensity = Global.envIntensity;

          item.material.metalness = 0.5;
          item.material.roughness = 0;
          item.material.opacity = 0.65;
          item.material.clearcoat = 0.2;
          item.material.transparent = true;
          item.material.refractionRatio = 0.9;
          item.material.ior = 0.9;
          item.material.reflectivity = 0.9;
        } else if (item.name.includes('model')) {
          item.material.metalness = 0.5;
          item.material.roughness = 0.5;
        }
        if (item.name.includes('model')) {
          this.cages.push(item);
        }
      }
    });

    this.road.traverse((child) => {
      if (child.isMesh) {
        Global.roadMeshes.push(child);
        // child.castShadow = true;
        child.receiveShadow = true;

        if (
          child.name.includes('collider') ||
          child.material.name.includes('collider')
        ) {
          child.visible = false;
          // if (child.name.includes('outer_collider')) {
          //   Global.wallCollider1 = child;
          //   child.material.side = THREE.BackSide;
          // }

          if (
            child.name.includes('inside_collider') ||
            child.material.name.includes('inside_collider')
          ) {
            // child.visible = true;
            Global.wallCollider2 = child;
            child.material.side = THREE.BackSide;
          }
        }
        child.material.envMapIntensity = Math.min(1, Global.envIntensity);
        if (child.material && child.material.map) {
          child.material.map.anisotropy = Global.maxAniso;
          child.material.map.colorSpace = THREE.SRGBColorSpace;
          child.material.map.encoding = THREE.sRGBEncoding;
        }
      }
    });
    this.city.traverse((child) => {
      if (child.isMesh && child.name.includes('point_')) {
        child.material.transparent = true;
        // child.material.opacity = 0;
      }
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }

      if (child.isMesh && child.material.map) {
        child.material.map.anisotropy = Global.maxAniso;
        child.material.envMapIntensity = Global.envIntensity;
        child.material.map.colorSpace = THREE.SRGBColorSpace;
        child.material.map.encoding = THREE.sRGBEncoding;
        if (
          child.name.includes('desert') ||
          child.material.name.includes('ROAD')
        ) {
          child.material.envMapIntensity = Math.min(1, Global.envIntensity);
        }
        if (child.material.name.includes('cars')) {
          child.material.envMapIntensity = Math.min(1, Global.envIntensity);

          child.material.metalness = 1;
          child.material.roughness = 0.4;
        }
      }
      if (
        child.material &&
        child.material.name.toLowerCase().includes('glass')
      ) {
        child.material.envMapIntensity = Math.min(1, Global.envIntensity);

        child.material.metalness = 0.8;
        child.material.roughness = 0;
        child.material.opacity = 1;
        child.material.clearcoat = 1;
        // child.material.transparent = true;
        // child.material.depthWrite = false;

        child.material.refractionRatio = 0.9;
        child.material.ior = 0.9;
        child.material.reflectivity = 0.2;
      }
    });
  }
  resetAndPlaySafely(audioElement) {
    // 1. Temporarily pause (optional, but can prevent a brief blip)
    audioElement.pause();

    // 2. Define the listener *before* setting currentTime
    const seekedHandler = () => {
      // 4. Play the audio after the seek is confirmed to be complete
      audioElement
        .play()
        .catch((error) => console.error('Play failed after seek:', error));

      // 5. Remove the listener to prevent memory leaks/multiple accidental plays
      audioElement.removeEventListener('seeked', seekedHandler);
    };

    // 3. Attach the listener
    audioElement.addEventListener('seeked', seekedHandler);

    // 4. Set currentTime to 0 to trigger the 'seeked' event
    audioElement.currentTime = 0;
  }
  // Update method for scene adjustments
  update(data) {
    if (this.wheel) {
      this.wheel.rotation.z += Global.delta * 0.003;
      this.cages.forEach((cage) => {
        cage.rotation.z -= Global.delta * 0.003;
      });
    }
    Global.pringles.forEach((pringle) => {
      pringle.rotation.y += Global.delta * 0.02 * pringle.userData.speed;
    });
  }

  dispose() {
    this.pringlesTI && clearInterval(this.pringlesTI);

    Global.pringles.forEach((pringle) => {
      pringle.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      if (pringle.userData.initScaleTwn) {
        pringle.userData.initScaleTwn.kill();
      }
      if (pringle.userData.removeScaleTwn) {
        pringle.userData.removeScaleTwn.kill();
      }
      this.scene.remove(pringle);
    });

    for (let i = 1; i <= 5; i++) {
      if (this[`point${i}`].userData.posTwn) {
        this[`point${i}`].userData.posTwn.kill();
      }
      if (this[`point${i}`].userData.alphaTwn) {
        this[`point${i}`].userData.alphaTwn.kill();
      }
      this[`point${i}`].geometry.dispose();
      this[`point${i}`].material.dispose();
      this.scene.remove(this[`point${i}`]);
    }
    if (this.city) {
      this.city.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.city);
      this.city = null;
    }
    if (this.road) {
      this.road.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.road);
      this.road = null;
    }
    if (this.wheel) {
      this.wheel.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.wheel);
      this.wheel = null;
    }

    // Remove event listeners (guard events)
    if (this.events) {
      this.events.removeEventListener('GAMESCENE_EVENTS', this.onEvents);
      this.events.removeEventListener('PLAYER_EVENTS', this.onEvents);
      this.events.removeEventListener('GAME_EVENTS', this.onEvents);
    }

    // Force garbage collection (for Chrome, mostly)
    if (window.gc) {
      window.gc();
    }
  }
}
